/**
 * Combine all reducers in this file and export the combined reducers.
 */
import { prestationsReducer } from "../pages/Prestations/Slices/Prestations.slice";
import { prestationReducer } from "../pages/Prestations/Slices/Prestation.slice";
import { institutionReducer } from "../pages/Institutions/Slices/Institution.slice";
import { institutionsReducer } from "../pages/Institutions/Slices/Institutions.slice";
import { userReducer } from "../pages/Institutions/Slices/InstitutionUser.slice";
import { interpreteReducer } from "../pages/Interpretes/Slices/InterpreteSlice";
import { interpretesReducer } from "../pages/Interpretes/Slices/InterpretesSlice";

import { logReducer } from "../pages/Logs/Slices/Log.slice";
import { logsReducer } from "../pages/Logs/Slices/Logs.slice";

import { usersReducer } from "../pages/Users/Slices/users.slice";

import { billReducer } from "../pages/Billing/Slices/Bill.slice";
import { billingReducer } from "../pages/Billing/Slices/Billing.slice";

import { principalReducer } from "../pages/Principals/Slices/Principal.slice";
import { principalsReducer } from "../pages/Principals/Slices/Principals.slice";
import { addressessReducer } from "../shared/container/Addresses/AddressesSlice/Addresses.slice";
import { responsablessReducer } from "../shared/container/Responsables/ResponsablesSlice/Responsables.slice";
import { userControlReducer } from "../pages/Users/Slices/user.slice";

// containers
//layouts

export default {
  log: logReducer,
  logs: logsReducer,
  billing: billingReducer,
  bill: billReducer,
  prestations: prestationsReducer,
  prestation: prestationReducer,
  institution: institutionReducer,
  principal: principalReducer,
  institutions: institutionsReducer,
  principals: principalsReducer,
  user: userReducer,
  userControl: userControlReducer,
  interprete: interpreteReducer,
  interpretes: interpretesReducer,
  addresses: addressessReducer,
  users: usersReducer,
  responsables: responsablessReducer,
};
